export default function AppSection() {
  return (
    <section id="app" className="bg-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">移动观影</h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-[500px] mx-auto">手机浏览器直接访问，无需下载，随时随地畅享海量影视</p>
          </div>

          <div className="max-w-[900px] mx-auto bg-background-200/60 rounded-2xl border border-background-200/50 overflow-hidden">
            <div className="flex flex-col md:flex-row items-center gap-8 p-8 md:p-12">
              <div className="flex-1">
                <h3 className="text-xl font-heading font-bold text-foreground-100 mb-4">移动端随时观影</h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-6">
                  成全影院移动端完美适配各类手机浏览器，无需下载安装任何APP，打开浏览器输入网址即可观看最新电影、热播新剧和热门综艺。支持手势控制音量亮度，横竖屏自由切换，流量播放自动提醒，WiFi环境自动选择最高清画质。无论是在通勤路上还是午休间隙，成全影院都是你手中的私人影院。
                </p>
                <div className="flex flex-wrap gap-3">
                  {['高清流畅', '手势控制', '投屏支持', '省流量模式', '横竖切换'].map((tag) => (
                    <span key={tag} className="text-xs px-3 py-1.5 rounded-full bg-primary-500/10 text-primary-300 border border-primary-500/20 whitespace-nowrap">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
              <div className="w-full md:w-[240px] flex-shrink-0">
                <div className="relative aspect-[9/16] rounded-xl overflow-hidden border border-background-300/40 shadow-lg">
                  <img
                    src="https://readdy.ai/api/search-image?query=Elegant%20mobile%20phone%20screen%20mockup%20displaying%20cinematic%20movie%20streaming%20app%20interface%20with%20dark%20theme%20and%20warm%20golden%20accents%2C%20movie%20poster%20thumbnails%20in%20grid%20layout%2C%20modern%20minimal%20UI%20design%20with%20rounded%20cards%20and%20subtle%20gradients%2C%20professional%20app%20showcase%20photography%20on%20dark%20background%20with%20soft%20ambient%20lighting%2C%20clean%20premium%20visual%20style&width=360&height=640&seq=app-mobile-screen&orientation=portrait"
                    alt="成全影院移动端观影体验"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}